import type { CSSProperties, SyntheticEvent } from "react";

export const NextPrevButtons = <T extends unknown>({
	currentItem,
	items,
	reverse,
	disabled,
	onChange,
	style,
}: {
	currentItem?: T;
	items: T[];
	reverse?: boolean;
	disabled?: boolean;
	onChange: (newItem: T) => void;
	style?: CSSProperties;
}) => {
	const index = currentItem === undefined ? -1 : items.indexOf(currentItem);

	type ButtonInfo = {
		disabled: boolean;
		onClick: (event: SyntheticEvent) => void;
	};

	const buttonInfo: [ButtonInfo, ButtonInfo] = [
		{
			disabled: disabled || index <= 0,
			onClick: (event) => {
				event.preventDefault();
				const newItem = items[index - 1];
				if (newItem !== undefined) {
					onChange(newItem);
				}
			},
		},
		{
			disabled: disabled || index >= items.length - 1,
			onClick: (event) => {
				event.preventDefault();
				const newItem = items[index + 1];
				if (newItem !== undefined) {
					onChange(newItem);
				}
			},
		},
	];

	// Seasons are displayed in reverse order in the dropdown, and "prev" should be "back in time"
	if (reverse) {
		buttonInfo.reverse();
	}

	return (
		<div className="btn-group" style={style}>
			<button
				className="btn btn-light-bordered btn-xs"
				disabled={buttonInfo[0].disabled}
				onClick={buttonInfo[0].onClick}
				title="Previous"
				aria-label="Previous"
				type="button"
			>
				<span className="glyphicon glyphicon-menu-left" />
			</button>
			<button
				className="btn btn-light-bordered btn-xs"
				disabled={buttonInfo[1].disabled}
				onClick={buttonInfo[1].onClick}
				title="Next"
				aria-label="Next"
				type="button"
			>
				<span className="glyphicon glyphicon-menu-right" />
			</button>
		</div>
	);
};
